export default {"src":"/_next/static/media/tracker.538f25c0.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};